import { LayoutFolderAPI } from '../../../api/genericLayout/LayoutFolderAPI';

export class LayoutFolderCommand {
    constructor(appName) {
        this.api = new LayoutFolderAPI(appName);
    }

    list(successCallback, errorCallback) {
        this.api.list()
            .then(result => { if (successCallback) successCallback(JSON.parse(result)); })
            .catch(() => { if (errorCallback) errorCallback("Ocorreu um erro a ler as pastas"); });
    }

    create(name, successCallback, errorCallback) {
        this.api.create({ name })
            .then(result => { if (successCallback) successCallback(JSON.parse(result)); })
            .catch(() => { if (errorCallback) errorCallback("Ocorreu um erro a criar a pasta"); });
    }

    rename(folderId, name, successCallback, errorCallback) {
        this.api.update(folderId, { name })
            .then(result => { if (successCallback) successCallback(JSON.parse(result)); })
            .catch(() => { if (errorCallback) errorCallback("Ocorreu um erro a renomear a pasta"); });
    }

    delete(folderId, successCallback, errorCallback) {
        this.api.delete(folderId)
            .then(() => { if (successCallback) successCallback(folderId); })
            .catch(() => { if (errorCallback) errorCallback("Ocorreu um erro a eliminar a pasta"); });
    }
}
